var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAsset = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 70,
  x: 20,
  y: 25,
  stroke: "currentColor",
  strokeWidth: 3,
  className: "raw",
  rx: 4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 50,
  r: 10,
  fill: "currentColor",
  className: "raw",
  opacity: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m20 80 20-20 20 20 20-20 20 20v15H20z",
  className: "raw",
  opacity: 0.3
})));
export default SvgAsset;